module.exports = "img/flags/EC.f44b301.png";